module.exports = __webpack_public_path__ + "img/wheelchair-symbol.064da0a0.png";